import { FormControl, ValidatorFn } from '@angular/forms';

export function OR(validators: ValidatorFn[], errorType) {
  return function (input: FormControl) {
    let result = {}
    validators.forEach(validator => {
      const validatorResult = validator(input);
      result = validatorResult === null ? validatorResult : result;
    })
    if (result === null) {
      return null
    } else {
      return {[errorType]: true};
    }
  }
}

export function AND(validators: ValidatorFn[], errorType) {
  return function (input: FormControl) {
    let result = null;
    validators.forEach(validator => {
      const validatorResult = validator(input);
      result = validatorResult !== null ? validatorResult : result;
    })
    if (result === null) {
      return null
    } else {
      return {[errorType]: true};
    }
  }
}

export function ValidatorA(input: FormControl) {
  return input.value === 'A' ? null : { ValidatorA: true };
}

export function ValidatorB(input: FormControl) {
  return input.value === 'B' ? null : { ValidatorA: true };
}

export function ValidatorAND1(input: FormControl) {
  return input.value.length > 4 ? null : { ValidatorAND1: true };
}

export function ValidatorAND2(input: FormControl) {
  return input.value.length < 7 ? null : { ValidatorAND2: true };
}
